import { ActionTracker } from '@dpdgroupuk/react-event-tracker';
import { API_HOST } from '../constants/app';

export default new ActionTracker({
  projectRef: 'FWMP',
  debug: false,
  productId: 19,
  url: `${API_HOST}/analytics`,
});
